module.exports = __webpack_public_path__ + "img/food-hero-econom.901b18ec.jpg";